import { FinalDecisionCodes, ResponseCodes } from '@modules/ridp/types/responseCodes';
import { RIDP_ACTION_TYPES } from '@constants/actionTypes/ridpActionTypes';
import { IUserInfo, IUserViewRef } from '@modules/ridp/types/ridpTypes';

interface ridpAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    currentUserInfo: {},
    viewRef: '',
    ridpPrimaryResponse: {},
    ridpSecondaryResponse: {},
    responseBasedErrorMessage: '',
    ridpValidateFARSResponse: {},
};

export default (state = INITIAL_STATE, action: ridpAction) => {
    switch (action?.type) {
        case RIDP_ACTION_TYPES.GET_CURRENT_USER_INFORMATION: {
            return {
                ...state,
                currentUserInfo: action.payload as IUserInfo,
                ridpPrimaryResponse: {},
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.GET_CURRENT_USER_VIEWREF: {
            return {
                ...state,
                viewRef: action.payload as IUserViewRef,
                ridpPrimaryResponse: {},
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
            };
        }
        case RIDP_ACTION_TYPES.VALIDATE_CURRENT_USER_INFORMATION: {
            const payload = action.payload;
            const isRidpRbaEnabled = state.currentUserInfo?.isRidpRbaEnabled;

            let currentUserInfoUpdate: Partial<IUserInfo> = { ...state.currentUserInfo };
            if (isRidpRbaEnabled) {
                currentUserInfoUpdate = {
                    ...state.currentUserInfo,
                    primaryAttempts: payload?.attempts,
                    timePeriodBlock: payload?.timePeriodBlock,
                    serviceContactName: payload?.serviceContactName,
                    serviceContactCallCenterNumber: payload.serviceContactCallCenterNumber,
                    ridpVerified: payload?.dvsVerificationResponse?.finalDecisionCode === FinalDecisionCodes.CONTINUE ? 'Y' : '',
                    ...(payload?.dvsVerificationResponse ?? {}),
                };
            } else {
                currentUserInfoUpdate = { ...state.currentUserInfo, ...payload?.verificationResponse };
            } 

            return {
                ...state,
                currentUserInfo: currentUserInfoUpdate,
                ridpPrimaryResponse: action.payload,
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.VALIDATE_IDENTITY_QUESTIONS: {
            return {
                ...state, 
                currentUserInfo: {
                    ...state.currentUserInfo,
                    ridpVerified: action.payload?.verificationResponse?.finalDecision === FinalDecisionCodes.ACC ? 'Y' : '',
                    ...action.payload?.verificationResponse
                },
                ridpSecondaryResponse: action.payload,
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.SET_ERROR_MESSAGE: {
            return {
                ...state,
                responseBasedErrorMessage: action.payload,
            };
        }
        case RIDP_ACTION_TYPES.UPLOAD_DOCUMENT: {
            if (action?.payload?.responseCode === ResponseCodes.HS000000) {
                return {
                    ...state,
                    currentUserInfo: {
                        ...state.currentUserInfo,
                        documentsUploaded: action.payload.documentsUploaded,
                    },
                };
            } else {
                return {
                    ...state,
                    responseBasedErrorMessage: 'ridp.manualverification.error.uploaddocument',
                };
            }
        }
        case RIDP_ACTION_TYPES.VALIDATE_FARS: {
            const farsPayload = action.payload;
            const isRidpRbaEnabled = state.currentUserInfo?.isRidpRbaEnabled;
            const ridpVerified = isRidpRbaEnabled
                ? (farsPayload?.dvsVerificationResponse?.finalDecisionCode === FinalDecisionCodes.CONTINUE ? 'Y' : '')
                : (farsPayload?.FinalDecisionCode === FinalDecisionCodes.ACC ? 'Y' : '');

            return {
                ...state,
                ridpValidateFARSResponse: farsPayload,
                currentUserInfo: {
                    ...state.currentUserInfo,
                    ridpSource: '',
                    ridpVerified,
                },
            };
        }

        default:
            return state;
    }
};
